export default __webpack_public_path__ + "static/media/i172jp.a2b69e7e.webp";